// ConfirmationDialog.js
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const ConfirmationDialog = ({
    open,
    title,
    message,
    detailsComponent,
    onConfirm,
    onCancel,
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmColor = "secondary",
    severity = "warning" // can be 'warning', 'error', 'info', etc.
}) => {
    // Map severity to background color
    const getBgColor = () => {
        switch (severity) {
            case 'error': return '#ffebee';
            case 'warning': return '#fff8e1';
            case 'info': return '#e3f2fd';
            case 'success': return '#e8f5e9';
            default: return '#f5f5f5';
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="confirmation-dialog-title"
        >
            <DialogTitle id="confirmation-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    {message}
                </Typography>
                {detailsComponent && (
                    <Box mt={2} p={2} bgcolor={getBgColor()} borderRadius={1}>
                        {detailsComponent}
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} variant="outlined">
                    {cancelText}
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained">
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    detailsComponent: PropTypes.node,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    confirmColor: PropTypes.string,
    severity: PropTypes.oneOf(['warning', 'error', 'info', 'success'])
};

export default ConfirmationDialog;